import { notify } from '../../components/notifications/notificationBridge';

import type { NotifierAction } from './reducer';

import { createUniqueKey } from '@/helpers/createUniqueKey';

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR' as const;
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR' as const;

export const enqueueSnackbar = (notification: NotifierAction['notification']) => {
  // signal UI bridge and keep Redux action record for backwards compatibility
  try {
    const title =
      typeof notification?.title === 'string' ? notification.title : notification?.message;

    notify({
      message: notification?.message,
      type: notification?.options?.variant,
      title,
    });
  } catch (e) {
    console.error('Notification bridge error:', e);
  }

  const key = notification?.options?.key;

  return {
    type: ENQUEUE_SNACKBAR,
    notification: {
      ...notification,
      key: key ?? createUniqueKey(),
      message: notification?.message,
      options: notification?.options,
    },
  };
};

export const removeSnackbar = (key: string | number) => ({
  type: REMOVE_SNACKBAR,
  key,
});
